import { Component, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { Events } from './services/events.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;
  headerMenuItem = {
    background: 'assets/imgs/background/39.jpg',
    image: 'assets/imgs/logo/2.png',
    title: 'Ionic5 UI - Mikky Theme'
  };
  public appPages = [
    {
      title: 'หน้าหลัก',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'ติดต่อเรา',
      url: '/contactus',
      icon: 'information'
    }
  ];

  userData: any;

  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private storage: Storage,
    private router: Router,
    private events: Events,
  ) {
    this.initializeApp();
    events.subscribe('user:login', () => {
      // user and time are the same arguments passed in `events.publish(user, time)`
      this.storage.get('packageHuay_user').then(user => {
        if (user) {
          this.userData = user;
          // this.router.navigate(['/home']);
          // this.router.navigate(['/report']);
        }
      });
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      this.storage.get('packageHuay_user').then(user => {
        if (user) {
          this.userData = user;
          // this.router.navigate(['/home']);
          // this.router.navigate(['/report']);
        }
      });
    });
  }

  ngOnInit() {
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }
  }

  onClickLogout() {
    this.storage.remove('packageHuay_user').then(logout => {
      this.userData = null;
      this.router.navigate(['/login']);
    });
  }
}
